import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchnlistAsync } from "../../store/apiSlice/NanylistSlice";
import Nannycard from "./Nannycard";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import WhatsApp_icon from '../../assets/img/WhatsApp_icon.png.webp';
import { isSpecialDate } from "../../utils/help";

const Nanylisting = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.rootReducer.Nlist.data);

  const {
    address, date, time, counter, divs,
    latitude, longitude, categoryId,
    appartment, house, street, summary,
  } = location.state;

  const [nannyListData, setNannyListData] = useState(null);
  const [categoriesDetail, setCategoriesDetail] = useState(null);

  // Filters
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [selectedAgeGroup, setSelectedAgeGroup] = useState(null);

  // Filter Options
  const nannySkillsOptions = [
    { value: 'Certified and trained', label: 'Certified and trained' },
    { value: 'Experienced with all age groups', label: 'Experienced with all age groups' },
    { value: 'Reliable and punctual', label: 'Reliable and punctual' },
    { value: 'Excellent communication skills', label: 'Excellent communication skills' },
    { value: 'Discreet and trustworthy', label: 'Discreet and trustworthy' },
    { value: 'Engages children in educational play', label: 'Engages children in educational play' },
    { value: 'Emotionally intelligent', label: 'Emotionally intelligent' },
    { value: 'Encourages healthy routines', label: 'Encourages healthy routines' },
    { value: 'Supports child development', label: 'Supports child development' },
    { value: 'Handles challenges calmly', label: 'Handles challenges calmly' },
    { value: 'Warm and nurturing personality', label: 'Warm and nurturing personality' },
    { value: 'Pet friendly', label: 'Pet friendly' },
    { value: 'Active and energetic', label: 'Active and energetic' },
    { value: 'Flexible and adaptable', label: 'Flexible and adaptable' },
    { value: 'Positive and proactive', label: 'Positive and proactive' },
    { value: 'Multilingual or fluent in English', label: 'Multilingual or fluent in English' },
    { value: 'Light household support', label: 'Light household support' },
    { value: 'Travel ready', label: 'Travel ready' },
    { value: 'First aid trained', label: 'First aid trained' },
    { value: 'Representable and well-groomed', label: 'Representable and well-groomed' },
  ];

  const languageOptions = [
    { value: 'English', label: 'English' },
    { value: 'Spanish', label: 'Spanish' },
    { value: 'French', label: 'French' },
    { value: 'German', label: 'German' },
    { value: 'Chinese', label: 'Chinese' },
    { value: 'Arabic', label: 'Arabic' },
    { value: 'Portuguese', label: 'Portuguese' },
    { value: 'Russian', label: 'Russian' },
    { value: 'Japanese', label: 'Japanese' },
    { value: 'Korean', label: 'Korean' },
    { value: 'Italian', label: 'Italian' },
    { value: 'Dutch', label: 'Dutch' },
    { value: 'Polish', label: 'Polish' },
    { value: 'Swedish', label: 'Swedish' },
    { value: 'Turkish', label: 'Turkish' },
    { value: 'Indonesian', label: 'Indonesian' },
    { value: 'Thai', label: 'Thai' },
    { value: 'Vietnamese', label: 'Vietnamese' },
    { value: 'Hebrew', label: 'Hebrew' },
  ];

  const mostExperienceAgeOptions = [
    { value: '0-4 years', label: '0-4 years' },
    { value: '0-8 years', label: '0-8 years' },
    { value: '0-12 years', label: '0-12 years' },
    { value: '4-8 years', label: '4-8 years' },
    { value: '8-12 years', label: '8-12 years' },
  ];

  useEffect(() => {
    const params = {
      ...location.state,
      // date : (new Date(date)).toLocaleDateString("en-GB"),
      skills: selectedSkills.map((s) => s.value).join(","),
      languages: selectedLanguages.map((l) => l.value).join(","),
      ageGroup: selectedAgeGroup?.value || "",
    };
    dispatch(fetchnlistAsync(params));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSkills, selectedLanguages, selectedAgeGroup]);

  useEffect(() => {
    if (data != null) {
      setNannyListData(data?.data?.data);
      if (data?.data?.categoriesDetail) {
        setCategoriesDetail(data.data.categoriesDetail);
      }
    }
  }, [data]);

  const phoneNumber = "+34617243659";
  const message = "Hello! I'm interested in your services.";
  const handleClick = () => {
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, "_blank");
  };

  return (
    <div>
      <div className="nanny_list_box ">
        <div className="nanny_banner">
        </div>
      </div>
      {/* Filter Section */}
      <div className="container mt-4">
        <div className="card shadow-sm border-0 rounded-4 p-4 mb-4" style={{ backgroundColor: "#f9f9f9" }}>
          <h5 className="fw-bold text-dark mb-3">Filter Nannies</h5>

          <div className="row g-3">
            {/* Skill Filter */}
            <div className="col-md-4">
              <label className="fw-semibold mb-2">Skills</label>
              <Select
                isMulti
                options={nannySkillsOptions}
                value={selectedSkills}
                onChange={setSelectedSkills}
                placeholder="Select skills"
              />
            </div>

            {/* Language Filter */}
            <div className="col-md-4">
              <label className="fw-semibold mb-2">Languages</label>
              <Select
                isMulti
                options={languageOptions}
                value={selectedLanguages}
                onChange={setSelectedLanguages}
                placeholder="Select languages"
              />
            </div>

            {/* Age Group Filter */}
            <div className="col-md-4">
              <label className="fw-semibold mb-2">Most Experienced Age Group</label>
              <Select
              isMulti
                options={mostExperienceAgeOptions}
                value={selectedAgeGroup}
                onChange={setSelectedAgeGroup}
                placeholder="Select age group"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Contact Card */}
      <div className="mt-4 container">
        <div className="card shadow-sm border-0 rounded-4 py-3 px-4" style={{ backgroundColor: "#f9f9f9" }}>
          <div className="d-flex align-items-center gap-3 flex-wrap">
            <div style={{ maxWidth: '50%' }}>
              <h6 className="fw-bold mb-2 text-dark">Want to see more nanny profiles?</h6>
              <p className="text-muted">Reach out to us and we'll help you connect with more trusted nannies near you.</p>
            </div>
            <img src={WhatsApp_icon} alt="WhatsApp" style={{ width: 40, height: 40, marginLeft: "auto" }} />
            <div>
              <p className="mb-1 fw-semibold text-dark" style={{ fontSize: '1rem' }}>+34 617 243 659</p>
              <p className="mb-0 text-muted" style={{ fontSize: '0.9rem' }}>info@nanny-line.com</p>
            </div>
            <button
              onClick={handleClick}
              className="btn btn-success rounded-3 ms-auto fw-semibold"
              style={{ fontSize: '0.95rem' }}
            >
              Send us a message!
            </button>
          </div>
        </div>
      </div>

      {/* Nanny Cards */}
      <div className="container sections_padding">
        {nannyListData ? (
          nannyListData.length > 0 ? (
            <div className="row">
              {nannyListData.map((item) => (
                <Nannycard
                  key={item.nannyId._id}
                  firstName={item.nannyId.firstName}
                  avgRating={item.nannyId.averageRating}
                  profileImage={item.nannyId.profileImage}
                  price={item.price}
                  isSpecialDate={isSpecialDate(date, item.price) !== 0}
                  lastName={item.nannyId.lastName}
                  address={item.nannyId.address}
                  userAddress={address}
                  date={date}
                  time={time}
                  counter={counter}
                  divs={divs}
                  latitude={latitude}
                  longitude={longitude}
                  nammylatitude={item.nannyId.latitude}
                  nammylongitude={item.nannyId.longitude}
                  categoryId={categoryId}
                  nannyId={item.nannyId._id}
                  categoriesDetail={categoriesDetail}
                  basePrice={item.price}
                  appartment={appartment}
                  house={house}
                  street={street}
                  summary={summary}
                />
              ))}
            </div>
          ) : (
            <p className="text-center text-muted">No nannies found with selected criteria.</p>
          )
        ) : (
          <p className="text-center text-muted">Loading nannies...</p>
        )}
      </div>
    </div>
  );
};

export default Nanylisting;
